import { Footer } from "../components/Footer";
import { TopBar } from "../components/TopBar";
import { useReveal } from "../lib/useReveal";
import { About } from "../sections/About";
import { Contact } from "../sections/Contact";
import { Experience } from "../sections/Experience";
import { Marquee } from "../sections/Marquee";
import { ProjectIndex } from "../sections/ProjectIndex";
import { WorkGrid } from "../sections/WorkGrid";

export function Home() {
  useReveal();

  return (
    <>
      <TopBar />
      <main id="top">
        <section className="hero">
          <div className="hero__intro">
            <span className="hero__eyebrow">
              Full-stack developer &amp; UI/UX designer — Sydney
            </span>
            <h1 className="hero__title">
              <span className="hero__hi">Hey, I&rsquo;m</span>
              <span>
                Adi <em>Kishore.</em>
              </span>
            </h1>
            <div className="hero__foot">
              <p>
                A full-stack developer and UI/UX designer passionate about
                creating digital experiences that delight users and drive
                results.
              </p>
              <a className="hero__cue" href="#work">
                <span>Selected work</span>
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M12 4v16m0 0-6-6m6 6 6-6" />
                </svg>
              </a>
            </div>
          </div>

          <figure className="hero__portrait">
            <img src="/images/adi-kishore.jpg" alt="Adi Kishore" />
            <figcaption>Adi Kishore · Sydney</figcaption>
          </figure>
        </section>

        <Marquee />
        <WorkGrid />
        <ProjectIndex />
        <Experience />
        <About />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
